<sb-card>
  <div card-header classes="no-border">
    <h3>{{'lang.globals.attributes' | translate}}</h3>
  </div>
  <div card-fit>
    <sb-comp-settings *ngPermissions="permissionService.Permission.location_attributes_show"
                      [location]="location"></sb-comp-settings>
  </div>
</sb-card>

